import { render } from "./TransactionsReport.vue?vue&type=template&id=5ffaa8b4&scoped=true"
import script from "./TransactionsReport.vue?vue&type=script&lang=js"
export * from "./TransactionsReport.vue?vue&type=script&lang=js"

import "./TransactionsReport.vue?vue&type=style&index=0&id=5ffaa8b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffaa8b4"]])

export default __exports__